module.exports = "/_next/static/images/GDGTrichy-8e7777c9e50303a3e19303fcc2d6f059.jpg";